function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SameSite = /*#__PURE__*/function (SameSite) {
  SameSite["strict"] = "strict";
  SameSite["lax"] = "lax";
  return SameSite;
}(SameSite || {});
function setCookie(key, value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    domain = _ref.domain,
    expires = _ref.expires,
    _ref$maxAge = _ref.maxAge,
    maxAge = _ref$maxAge === void 0 ? 60 * 60 * 24 * 30 : _ref$maxAge,
    secure = _ref.secure,
    sameSite = _ref.sameSite;
  if (!key) return;
  value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
  key = encodeURIComponent(String(key));
  key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
  key = key.replace(/[()]/g, escape);
  var attrs = [];
  if (path) attrs.push("path=" + path); // path 非常重要, 默认是  location.pathname , 在删除或者修改 cookie 时候, path 没有对齐是无法修改 cookie 的.
  if (domain) attrs.push("domain=" + domain);
  if (expires) attrs.push("expires=" + expires);
  if (maxAge) attrs.push("max-age=" + maxAge); // important:"max-age" is not supported by IE6/7/8
  if (secure) attrs.push('secure');
  if (sameSite) attrs.push("samesite=" + sameSite);
  document.cookie = key + "=" + value + ";" + attrs.join(';');
}

// 为确保获取到相对正确的cookie值，使用domain作为排序的依据
function getCookiePair(key) {
  var _document$cookie;
  var cookies = ((_document$cookie = document.cookie) === null || _document$cookie === void 0 ? void 0 : _document$cookie.split('; ')) || [];
  var REDCode = /(%[0-9A-Z]{2})+/g;
  var domainPart = "domain=" + location.hostname;
  cookies.sort(function (a) {
    return a.includes(domainPart) ? -1 : 0;
  });
  for (var _iterator = _createForOfIteratorHelperLoose(cookies), _step; !(_step = _iterator()).done;) {
    var cookie = _step.value;
    var parts = cookie.split('=');
    var hasDomain = cookie.includes(domainPart);
    try {
      if (key === parts[0].replace(REDCode, decodeURIComponent)) {
        return [parts.slice(1).join('=').replace(REDCode, decodeURIComponent), hasDomain];
      }
    } catch (e) {
      // do nothing
    }
  }
  return ['', false];
}
export { setCookie, getCookiePair };